import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import firebaseAuthService from './firebaseAuthService';

class FirebaseInitService {
  constructor() {
    this.isInitialized = false;
    this.initPromise = null;
  }

  async initialize() {
    if (this.initPromise) return this.initPromise;
    this.initPromise = this._performInitialization();
    return this.initPromise;
  }

  async _performInitialization() {
    try {
      console.log('🚀 Initializing ExpertGuru Core Services...');
      
      // 1. Initialize Auth State
      firebaseAuthService.initialize();
      
      // 2. Setup Base Settings
      await this.initializeAppSettings();
      
      // 3. Ensure Admin User Exists
      await firebaseAuthService.createAdminUser();
      
      // 4. Setup Templates
      await this.initializeDefaultTemplates();

      this.isInitialized = true;
      console.log('✅ Core Services Ready');
      return { success: true };
    } catch (error) {
      console.error('❌ Initialization failed:', error);
      // Don't block the app, but log it
      return { success: false, error: error.message };
    }
  }

  async emergencyInitialization() {
    this.initPromise = null;
    return this._performInitialization();
  }

  async initializeAppSettings() {
    const settingsRef = doc(db, 'appSettings', 'default');
    const settingsDoc = await getDoc(settingsRef);
    if (!settingsDoc.exists()) {
      await setDoc(settingsRef, {
        id: 'default',
        companyName: 'ExpertGuru',
        brandColor: '#4f46e5',
        currency: 'USD',
        currencySymbol: '$',
        exchangeRate: 1,
        welcomeTemplateId: 'template-welcome-email',
        resetPasswordTemplateId: 'template-reset-password',
        reminderTemplateId: 'template-payment-reminder'
      });
    }
  }

  async initializeDefaultTemplates() {
    const templates = [
      {
        id: 'template-welcome-email',
        name: 'Welcome Email',
        type: 'email',
        subject: 'Welcome to {companyName}!',
        body: 'Hello {firstName},\n\nYour account has been created successfully.\n\nUsername: {email}\nPassword: {password}\n\nLogin here: {companyName}',
        isSystem: true
      },
      {
        id: 'template-reset-password',
        name: 'Password Reset Instructions',
        type: 'email',
        subject: 'Reset your {companyName} Password',
        body: 'Hello {firstName},\n\nWe received a request to reset your password. If this was not you, please ignore this email.\n\nClick the secure link in your browser to proceed.',
        isSystem: true
      },
      {
        id: 'template-payment-reminder',
        name: 'Overdue Balance Reminder',
        type: 'email',
        subject: 'Payment Required: {studentName}',
        body: 'Dear {parentName},\n\nThis is a friendly reminder that there is an outstanding balance of {amountDue} for {studentName}.\n\nPlease login to the portal to settle this.',
        isSystem: true
      }
    ];

    for (const t of templates) {
      const ref = doc(db, 'messageTemplates', t.id);
      const d = await getDoc(ref);
      if (!d.exists()) {
        await setDoc(ref, { ...t, createdAt: new Date().toISOString() });
      }
    }
  }
}

const firebaseInitService = new FirebaseInitService();
export default firebaseInitService;